import { Component, OnInit } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl, FormGroup } from '@angular/forms';
import { FacebookService } from "ngx-facebook";
import { TwitterService } from '../../../social/twitter/twitter.service';
import { LinkedinService } from '../../../social/linkedin/linkedin.service';
import { ToastrService } from 'ngx-toastr';
import { CommerceService } from '../../../core/service/app/commerce.service';

interface SocialData {
  id: number;
  name: string;
  photo: string;
  data: string;
  conected: boolean;
}

@Component({
  selector: 'app-commerce-social-networks-form',
  templateUrl: './commerce-social-networks-form.component.html',
  styleUrls: ['./commerce-social-networks-form.component.scss']
})
export class CommerceSocialNetworksFormComponent extends FormBaseComponent<any> implements OnInit {

  facebookImg;

  twitterInfo = {};

  linkedinInfo = {};

  constructor(private cs: CommerceService, private fb: FacebookService, private ts: TwitterService, private ls: LinkedinService, private toastrService: ToastrService) {
    super();
    this.fb.init({
      appId: '530848670597404',
      xfbml: true,
      version: 'v2.8'
    });
  }

  ngOnInit() {
    this.init();
    this.ts.subject.subscribe(data => {
      //console.log(data);
      this.form.get('twitter').patchValue(
        {
          name: data.name,
          photo: data.profile_image_url,
          data: '',
          conected: true });
      this.twitterInfo = data;
    })
  }

  template() {
    this.form.addControl('facebook', new FormGroup({
      'id': new FormControl(''),
      'name': new FormControl(''),
      'photo': new FormControl(''),
      'data': new FormControl(''),
      'conected': new FormControl(false),
    }));
    this.form.addControl('twitter', new FormGroup({
      'id': new FormControl(''),
      'name': new FormControl(''),
      'photo': new FormControl(''),
      'data': new FormControl(''),
      'conected': new FormControl(false),
    }));
    this.form.addControl('linkedin', new FormGroup({
      'id': new FormControl(''),
      'name': new FormControl(''),
      'photo': new FormControl(''),
      'data': new FormControl(''),
      'conected': new FormControl(false),
    }));
    this.form.addControl('description', new FormControl());
  }

  get faceData(): SocialData {
    return this.form.get('facebook').value;
  }
  get linkData(): SocialData {
    return this.form.get('linkedin').value;
  }
  get twittData(): SocialData {
    return this.form.get('twitter').value;
  }


  facebook() {
    this.fb.login({ scope: 'email,user_photos,user_posts' })
      .then(response => {
        this.fb.api(response.authResponse.userID + '/picture').then(data => {
          this.facebookImg = data.data.url;
          this.fb.api(response.authResponse.userID + '/posts').then(dataPost => {
            let p = '';
            dataPost.data.forEach(post => {
              p += '{ postId: ' + post.id + ', message: ' + (post.message || '') + ', story: ' + post.story + ', createdTime: ' + post.created_time + ' }'
            })
            this.form.get('facebook').patchValue({ name: 'facebook', photo: this.facebookImg, data: p, conected: true });
            //this.cs.saveFacebook({ name: 'Facebook', photo: this.facebookImg, facebookPosts: posts });
          })
        });
      })
      .catch(error => console.log(error));
  }

  twitter() {
    /*setTimeout(() => {
      this.toastrService.error('Error al conectar.', 'Error')
    }, 3000);*/
    this.ts.login();
  }

  linkedin() {
    this.ls.loginLinkedin()
    this.ls.linkedinSubject.subscribe(data => {
      if (data.isAuth) {
        this.form.get('linkedin').patchValue(
          {
            name: data.firstName + ' ' + data.lastName,
            photo: data.photo,
            data: '',
            conected: true
          });
      }
      //this.linkedinInfo = data;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/commerce-social-networks-form/commerce-social-networks-form.component.ts